<template>
  <b-modal
    ref="modal"
    title="Redditi - reddito persona"
    size="lg"
    no-close-on-backdrop
  >
    <div class="row">

      <div class="col-12 px-3">
        <div
          class="mb-2 font-weight-bold mt-3 text-muted text-left text-uppercase"
          style="font-size:.9rem; border-bottom:1px solid #ddd"
        >
          Dichiarante:
        </div>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>cognome</label>
        <b-input
          v-model.trim="reddito.cognome"
          type="text"
          :formatter="formatUcase"
          size="sm"
          :state="fieldState('cognome')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.cognome.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>nome</label>
        <b-input
          v-model.trim="reddito.nome"
          type="text"
          :formatter="formatUcase"
          size="sm"
          :state="fieldState('nome')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.nome.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>data nascita</label>
        <b-input
          v-model.trim="reddito.dataNascita"
          type="date"
          :formatter="formatUcase"
          size="sm"
          :state="fieldState('dataNascita')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.dataNascita.required">Campo obbligatorio</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.reddito.dataNascita.verificaNascita">Verificare anno di nascita.</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>codice fiscale</label>
        <b-input
          v-model.trim="reddito.codiceFiscale"
          type="text"
          :formatter="formatUcase"
          size="sm"
          :state="fieldState('codiceFiscale')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.codiceFiscale.codiceFiscaleExtended">Codice fiscale errato!</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >

        <label>Parentela</label>
        <b-form-select
          v-model="reddito.relazioneAssegnatario.id"
          :options="tipoComponenteOptions"
          size="sm"
          :state="fieldState('relazioneAssegnatario')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.relazioneAssegnatario.required">Campo obbligatorio</b-form-invalid-feedback>

        <!-- <label>relazione con assegnatario</label>
        <b-input
          v-model.trim="reddito.relazioneAssegnatario"
          type="text"
          :formatter="formatUcase"
          size="sm"
          :state="fieldState('nome')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.relazioneAssegnatario.required">Campo obbligatorio</b-form-invalid-feedback> -->
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>data entrata/uscita</label>
        <b-input
          v-model.trim="reddito.dataInOut"
          type="date"
          size="sm"
          :state="fieldState('dataInOut')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.dataInOut.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div class="col-12 px-3">
        <div
          class="mb-2 font-weight-bold mt-3 text-muted text-left text-uppercase"
          style="font-size:.9rem; border-bottom:1px solid #ddd"
        >
          Dati redditi:
        </div>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>lavoro dipendente e/o pensioni</label>
        <b-input
          class="text-right"
          v-model.trim="reddito.importoRedditiDipendente"
          type="number"
          size="sm"
          :state="fieldState('importoRedditiDipendente')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.importoRedditiDipendente.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>lavoro autonomo</label>
        <b-input
          class="text-right"
          v-model.trim="reddito.importoRedditiAutonomo"
          type="number"
          size="sm"
          :state="fieldState('importoRedditiAutonomo')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.importoRedditiAutonomo.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>altri redditi</label>
        <b-input
          class="text-right"
          v-model.trim="reddito.importoRedditiAltri"
          type="number"
          size="sm"
          :state="fieldState('importoRedditiAltri')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.importoRedditiAltri.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-6 stack-label"
      >
        <label>non fiscalmente imponibili</label>
        <b-input
          class="text-right"
          v-model.trim="reddito.importoRedditiNonImp"
          type="number"
          size="sm"
          :state="fieldState('importoRedditiNonImp')"
        />
        <b-form-invalid-feedback v-if="!$v.reddito.importoRedditiNonImp.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div
        role="group"
        class="col-12 col-md-3 stack-label"
      >
        <label>è presente un disabile</label>
        <b-check
          v-model="reddito.handicap"
          size="sm"
          :state="fieldState('categoria')"
        />
      </div>
    </div>

    <template slot="modal-footer">

      <b-button
        v-if="idx===-1"
        variant="success"
        @click="add"
      >
        <font-awesome-icon icon="plus" /> Aggiungi
      </b-button>

      <b-button
        v-else
        variant="success"
        @click="update"
      >
        <font-awesome-icon icon="edit" /> Aggiorna
      </b-button>

      <b-button
        v-if="idx!==-1"
        variant="danger"
        @click="remove"
      >
        <font-awesome-icon
          icon="trash-alt"
          class="mr-2"
        /> Rimuovi reddito
      </b-button>

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        /> Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
// import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import 'numeral/locales'
import moment from 'moment'
import CodiceFiscale from '../utils/codice-fiscale'

// const codiceFiscale = (value, vm) => {
//   if (!value) return true
//   try {
//     let cf1 = CodiceFiscale.computeInverse(value)
//     // console.log('CodiceFiscale.computeInverse', vm)
//     if (vm.dataNascita) {
//       let dn = vm.dataNascita.split('-')
//       cf1.name = vm.nome
//       cf1.surname = vm.cognome
//       cf1.day = parseInt(dn[2])
//       cf1.month = parseInt(dn[1])
//       cf1.year = parseInt(dn[0])
//       let cf2 = CodiceFiscale.compute(cf1)
//       // console.log('cf2 - cf1', cf2, JSON.stringify(cf1), cf2.substr(0, 15) === value.toUpperCase().substr(0, 15))
//       return cf2.substr(0, 15) === value.toUpperCase().substr(0, 15)
//     }
//     return true
//   } catch (err) {
//     return false
//   }
// }

const codiceFiscaleExtended = (value, vm) => {
  let idRet = true
  if (!value) idRet = false
  try {
    let cf1 = CodiceFiscale.computeInverse(value)
    if (vm.dataNascita && idRet) {
      let dn = vm.dataNascita.split('-')
      cf1.name = vm.nome
      cf1.surname = vm.cognome
      cf1.day = parseInt(dn[2])
      cf1.month = parseInt(dn[1])
      cf1.year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', cf1.year, cf1.year < 1900, cf1.year > new Date().getFullYear())
      if (cf1.year < 1900 || cf1.year > new Date().getFullYear()) {
        idRet = false
      } else {
        let cf2 = CodiceFiscale.compute(cf1)
        idRet = cf2.substr(0, 15) === value.toUpperCase().substr(0, 15)
      }
      return idRet
    }
    return true
  } catch (err) {
    return false
  }
}

const verificaNascita = (value, vm) => {
  let idRet = true
  if (!value) idRet = false
  try {
    if (vm.dataNascita && idRet) {
      let dn = vm.dataNascita.split('-')
      let year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', year, year < 1900, year > new Date().getFullYear())
      if (year < 1900 || year > new Date().getFullYear()) idRet = false
    }
    return idRet
  } catch (err) {
    return false
  }
}

export default {
  name: 'redditiPatrimonioModal',

  data () {
    return {
      idx: -1,
      item: {},
      reddito: this.emptyReddito()
    }
  },

  computed: {
    tipoComponenteOptions () {
      return this.$store.state.options.tipoComponente
    }
  },

  validations: {
    reddito: {
      cognome: { required },
      nome: { required },
      dataNascita: { required, verificaNascita },
      codiceFiscale: { codiceFiscaleExtended },
      relazioneAssegnatario: { required },
      dataInOut: { required },
      importoRedditiDipendente: { minValue: minValue(0) },
      importoRedditiAutonomo: { minValue: minValue(0) },
      importoRedditiAltri: { minValue: minValue(0) },
      importoRedditiNonImp: { minValue: minValue(0) }
    }
  },

  methods: {
    emptyReddito () {
      return {
        cognome: '',
        nome: '',
        dataNascita: '',
        codiceFiscale: '',
        relazioneAssegnatario: {},
        dataInOut: '',
        importoRedditiDipendente: 0,
        importoRedditiAutonomo: 0,
        importoRedditiAltri: 0,
        importoRedditiNonImp: 0,
        handicap: false
      }
    },

    fieldState (field) {
      let v = this.$v.reddito[field]
      return v && v.$dirty && v.$error ? false : null
    },

    async open ({ item, idx }) {
      this.$v.$reset()
      this.item = item
      this.idx = idx >= 0 ? idx : -1
      // console.log('TEST LODASH cloneDeep', cloneDeep(item.redditi[idx]))
      this.reddito = idx >= 0 ? cloneDeep(item.redditi[idx]) : this.emptyReddito()
      // console.log('PRIMA this.reddito.dataNascita', this.reddito.dataNascita)
      if (this.reddito.dataNascita) {
        this.reddito.dataNascita = moment(this.reddito.dataNascita, 'YYYY-MM-DD', true).isValid() ? moment(this.reddito.dataNascita, 'YYYY-MM-DD', true).format('YYYY-MM-DD') : moment(this.reddito.dataNascita, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
      }
      // console.log('DOPO this.reddito.dataNascita', this.reddito.dataNascita)

      if (typeof this.reddito.relazioneAssegnatario === 'string') this.reddito.relazioneAssegnatario = {}
      // this.searchComune = ''
      await this.$store.dispatch('options/loadTipoComponenteOptions')
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    add () {
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        let relazioneAssegnatario = this.tipoComponenteOptions.find(x => x.value === this.reddito.relazioneAssegnatario.id).text
        this.reddito.relazioneAssegnatario.text = relazioneAssegnatario
        // console.log('prima della push', this.item.redditi, this.tipoComponenteOptions)
        if (!this.item.redditi) this.$set(this.item, 'redditi', [this.reddito])
        else this.item.redditi.push(this.reddito)
        // console.log('dopo la push', this.item.redditi)
        this.close()
      }
    },

    update () {
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        let relazioneAssegnatario = this.tipoComponenteOptions.find(x => x.value === this.reddito.relazioneAssegnatario.id).text
        this.reddito.relazioneAssegnatario.text = relazioneAssegnatario
        // console.log('prima della set', this.item.redditi, this.tipoComponenteOptions)
        this.$set(this.item.redditi, this.idx, this.reddito)
        this.close()
      }
    },

    remove () {
      this.item.redditi.splice(this.idx, 1)
      this.close()
    },
    formatUcase (value, event) {
      return value.toUpperCase()
    },
    formatValuta (value, event) {
      let valore = new Intl.NumberFormat('it-IT').format(value)
      // console.log('Valore', valore)

      return valore
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-left >>> button {
  text-align: left !important;
}
</style>
